/**
 * A hook to access category data.
 *
 * - If no `categoryId` is provided, it will try to find the currently selected category and return it.
 * - If no `categoryId` is provided and no category is found, it will try to find the currently selected article and return article.category.
 * - Where `categoryId` is provided and if home is defined (see [[useHome]]), it will try match `categoryId` to one of home.categories and try to return the find result.
 * - If none of the above are found, returns `undefined`.
 */
import { useContext } from 'react';
import useArticle from './useArticle';
import useHome from './useHome';
import { CategoryContext } from '../contexts';
/**
 *
 * # useCategory
 *
 * Usage example:
 * ```javascript
 * import useCategory from "@elevio/kb-kit/lib/hooks/useCategory";
 *
 * function MyComponent({categoryId}) {
 *   const category = useCategory(categoryId);
 *   console.log(category); // ICategory | undefined
 *
 *   return (
 *     ...
 *   )
 * }
 * ```
 */
export default function useCategory(categoryId) {
    const home = useHome();
    const category = useContext(CategoryContext);
    const article = useArticle();
    if (!categoryId) {
        if (category)
            return category;
        if (article)
            return article.category;
        return undefined;
    }
    if (home && home.categories) {
        const _category = home.categories.find((c) => c.id === categoryId);
        if (_category)
            return _category;
    }
    return undefined;
}
//# sourceMappingURL=useCategory.js.map